import { colord } from 'colord'

/**
 * A theme color at a given opacity, as `rgba(...)`.
 *
 * Themes are authored as hex, so a surface the design draws semi-transparent
 * can't just be looked up — it has to be composed from the opaque token. Any
 * alpha already on the token is multiplied in, so a token that is itself
 * translucent doesn't get promoted.
 *
 * A color `colord` can't parse is returned untouched: a host may hand the theme
 * something exotic, and a wrong color is worse than an un-dimmed one.
 */
export function withAlpha(color: string, alpha: number): string {
  // Fully opaque is the token itself — no reason to rewrite it into `rgba()`.
  if (alpha >= 1) {
    return color
  }
  const parsed = colord(color)
  if (!parsed.isValid()) {
    return color
  }
  return parsed.alpha(parsed.alpha() * alpha).toRgbString()
}
